/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { mapValues } from '../runtime';
/**
 * Check if a given object implements the ApiKey interface.
 */
export function instanceOfApiKey(value) {
    return true;
}
export function ApiKeyFromJSON(json) {
    return ApiKeyFromJSONTyped(json, false);
}
export function ApiKeyFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['Id'] == null ? undefined : json['Id'],
        'key': json['Key'] == null ? undefined : json['Key'],
        'active': json['Active'] == null ? undefined : json['Active'],
    };
}
export function ApiKeyToJSON(json) {
    return ApiKeyToJSONTyped(json, false);
}
export function ApiKeyToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Id': value['id'],
        'Key': value['key'],
        'Active': value['active'],
    };
}
